var ReferralStatsPeriods = /* @__PURE__ */ ((ReferralStatsPeriods2) => {
  ReferralStatsPeriods2[ReferralStatsPeriods2["ALL_TIME"] = 0] = "ALL_TIME";
  ReferralStatsPeriods2[ReferralStatsPeriods2["TODAY"] = 1] = "TODAY";
  ReferralStatsPeriods2[ReferralStatsPeriods2["DAYS_7"] = 6] = "DAYS_7";
  ReferralStatsPeriods2[ReferralStatsPeriods2["DAYS_30"] = 4] = "DAYS_30";
  return ReferralStatsPeriods2;
})(ReferralStatsPeriods || {});
export {
  ReferralStatsPeriods
};
